import * as React from "react";
import Icon from "./icon";
import { ReImage } from "./reimage";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const placeholderClass = css({
    borderRadius: "50%",
    backgroundColor: getThemeColorVar("background", "light"),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
});
const imageClass = css({
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
    backgroundSize: "cover",
});
export const PersonImage = (props) => {
    const effectiveDimension = props.dimension || 50;
    const dimension = `${effectiveDimension}px`;
    const dimensionStyle = css({
        width: dimension,
        height: dimension,
    });
    if (props.src) {
        return (React.createElement("div", { className: cx(imageClass, dimensionStyle) },
            React.createElement(ReImage, { width: [effectiveDimension, "px"], height: [effectiveDimension, "px"], src: props.src })));
    }
    else {
        return (React.createElement("div", { className: cx(placeholderClass, dimensionStyle) },
            React.createElement(Icon, { name: "picture", size: "regular" })));
    }
};
export default PersonImage;
//# sourceMappingURL=personimage.js.map